import FadeText from "./fadeText.container";

export default FadeText;
